import React from 'react';
import { ArrowALeftIcon16Light } from "../../../internal/icons2022/ArrowALeftIcon/ArrowALeftIcon16Light";
import { ArrowALeftIcon20Light } from "../../../internal/icons2022/ArrowALeftIcon/ArrowALeftIcon20Light";
import { ArrowALeftIcon24Regular } from "../../../internal/icons2022/ArrowALeftIcon/ArrowALeftIcon24Regular";
import { iconSizer } from "../../../internal/icons2022/iconSizer";
export var ArrowLeftIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(ArrowALeftIcon16Light, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(ArrowALeftIcon20Light, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(ArrowALeftIcon24Regular, null);
  }
}, 'ArrowLeftIcon');